<template>
  <div class="table-responsive margin-top-1-perc">
    <table class="table table-striped">
      <thead>
        <tr>
          <th v-for="(key,index) in columns" 
            @click="sortBy(key.ColumnName)"
            :class="{ active: sortKey == key.ColumnName }" class="border-right border-left border-top border-bottom text-align-center width" :key="index">
            {{ key.ColumnAlias | capitalize }}
            <span class="arrow" :class="checkSortable(key.ColumnName) == true ? (sortOrders[key.ColumnName] > 0 ? 'asc' : 'dsc') : 'none'">
            </span>
          </th>
        </tr>
      </thead>
      <tbody class="border-bottom">
        <tr v-for="(entry,index1) in filteredData" :key="index1">
          <td v-for="(key,index2) in columns" class="border-right border-left width" :key="index2">
            <span v-if="isLinkColumn(key.ColumnName)" class="text-decoration-underline text-color-blue cursor-pointer" @click="updateDetails($event,key.ColumnName,entry)">
              <!-- <a href=""> {{entry[key.ColumnName]}}</a>   -->
              {{entry[key.ColumnName]}}
            </span>
            <span v-else>
              <span v-if="isVideoPlayerColumn(key.ColumnName)">
                <video controls controlsList="nodownload" class="video-width-height" :id="'video_'+index1" v-if="entry[key.ColumnName] !== null && entry[key.ColumnName] !== undefined">
                  <source :src=entry[key.ColumnName] type="video/mp4">
                </video>
                <!-- <audio controls class="audio-width" controlsList="nodownload">
                  <source :src="AudioUrlValue" type="audio/mp3">
                </audio> -->
              </span>
              <span v-else-if="isAudioPlayerColumn(key.ColumnName)">
                <audio controls class="audio-width" controlsList="nodownload" :id="'audio_'+index1" v-if="entry[key.ColumnName] !== null && entry[key.ColumnName] !== undefined">
                  <source :src=entry[key.ColumnName] type="audio/mp3">
                </audio>
              </span>
              <span v-else v-html=entry[key.ColumnName] :class="{'text-align-left' : key.ColumnName === 'TrafficLightScore'}">
                <!-- {{entry[key.ColumnName]}} -->
              </span>  
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>  
</template>

<script>
export default {
  props: {
    data: Array,
    columns: Array,
    sortColumns: Array,
    filterKey: String,
    linkColumns: Array
  },
  data: function () {
    if (this.data === undefined || this.data === null) {
      return
    }
    var sortOrders = {}
    /* this.columns.forEach(function (key) {
      sortOrders[key] = 1
    }) */
    this.sortColumns.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      sortKey: '',
      sortOrders: sortOrders
    }
  },
  components: {},
  computed: {
    filteredData: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return data
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      // AK: Used to Pause all playing Audio before to load new url to it
      for (var i = 0; i < this.filteredData.length; i++) {
        var audio = document.getElementById('audio_' + i)
        if (audio !== undefined && audio !== null) {
          audio.pause()
        }
      }
      // AK: Used to Pause all playing videos before to load new url to it
      for (i = 0; i < this.filteredData.length; i++) {
        var video = document.getElementById('video_' + i)
        if (video !== undefined && video !== null) {
          video.pause()
        }
      }
      if (this.sortColumns.indexOf(key) > -1) {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
      }
      // AK: Used to load newly added video in Video Tag
      for (i = 0; i < this.filteredData.length; i++) {
        video = document.getElementById('video_' + i)
        if (video !== undefined && video !== null) {
          video.load()
        }
      }
      // AK: Used to load newly added audio in Audio Tag
      for (i = 0; i < this.filteredData.length; i++) {
        audio = document.getElementById('audio_' + i)
        if (audio !== undefined && audio !== null) {
          audio.load()
        }
      }
    },
    checkSortable: function (key) {
      return this.sortColumns.indexOf(key) > -1
    },
    isLinkColumn: function (key) {
      return this.linkColumns.indexOf(key) > -1
    },
    isVideoPlayerColumn: function (key) {
      var videoColumnName = ['ResponseVideoUrl']
      return videoColumnName.indexOf(key) > -1
    },
    isAudioPlayerColumn: function (key) {
      console.log('isAudioPlayerColumn >>> ' + key)
      var audioColumnName = ['ResponseAudioUrl']
      return audioColumnName.indexOf(key) > -1
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* table {
  border: 2px solid #f39c12;
  border-radius: 3px;
  background-color: #fff;
}

th {
  background-color: #f39c12;
  color: rgba(255,255,255,0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

td {
  background-color: #f9f9f9;
}

th, td {
  min-width: 120px;
  padding: 10px 20px;
}

th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
} */
.video-width-height {
  width: 250px;
  height: 250px;
}
.cursor-pointer{
  cursor: pointer;
}
.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}

.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}

.arrow.none{
  display: none;
}
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.border-right{
    border-right: 1px solid #aaa !important;
}
.border-left{
    border-left: 1px solid #aaa !important;
}
.border-top{
    border-top: 1px solid #aaa !important;
}
.border-bottom{
    border-bottom: 1px solid #aaa !important;
}
.border{
  border:0 !important;
}
.text-align-center{
  text-align: center !important;
}
.width{
 width: 20% !important;
}

.text-align-left{
  text-align: left !important;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/SortableGridForSubLinks.vue